import { WalletError } from '@tronweb3/tronwallet-abstract-adapter'
import { AppkitError } from '../appkit'

const isTronWalletError = (e: unknown): e is TronWalletError =>
  TRON_WALLET_ERROR_CODES.includes((<TronWalletError>e)?.name)

export interface TronWalletError<
  T extends TronWalletErrorCode = TronWalletErrorCode
> extends WalletError {
  /**
   *  The string error code.
   */
  name: T
}

type TronWalletErrorCode =
  | 'WalletError'
  | 'WalletNotFoundError'
  | 'WalletNotSelectedError'
  | 'WalletDisconnectedError'
  | 'WalletConnectionError'
  | 'WalletDisconnectionError'
  | 'WalletSignMessageError'
  | 'WalletSignTransactionError'
  | 'WalletWalletLoadError'
  | 'WalletWindowClosedError'
  | 'WalletSwitchChainError'
  | 'WalletGetNetworkError'

/**
 * [docs](https://github.com/tronweb3/tronwallet-adapter/blob/main/packages/adapters/abstract-adapter/src/errors.ts)
 */
const TRON_WALLET_ERROR_CODES = [
  'WalletError',
  'WalletNotFoundError',
  'WalletNotSelectedError',
  'WalletDisconnectedError',
  'WalletConnectionError',
  'WalletDisconnectionError',
  'WalletSignMessageError',
  'WalletSignTransactionError',
  'WalletWalletLoadError',
  'WalletWindowClosedError',
  'WalletSwitchChainError',
  'WalletGetNetworkError'
] as const

type CamelToSnakeCase<S extends string> = S extends `${infer T}${infer U}`
  ? `${T extends Capitalize<T> ? '_' : ''}${Uppercase<T>}${CamelToSnakeCase<U>}`
  : S

export type TronAppkitErrorCode = `TRON${CamelToSnakeCase<TronWalletErrorCode>}`

export type TronAppkitError = AppkitError<TronAppkitErrorCode>

const factories = [
  {
    is: isTronWalletError,
    make: (e: TronWalletError): TronAppkitError => {
      console.error('makeAppkitError')
      console.dir(e)
      return Object.assign(new AppkitError<TronAppkitErrorCode>(), {
        code: `TRON${e.name.replace(/([A-Z])/g, '_$1').toUpperCase()}`,
        message: e.message,
        error: e
      })
    }
  },
  {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    is: (_e: unknown) => true,
    make: (e: unknown): TronAppkitError => {
      console.error('makeAppkitError')
      console.dir(e)
      return Object.assign(new AppkitError<TronAppkitErrorCode>(), {
        code: 'TRON_WALLET_ERROR',
        error: e
      })
    }
  }
]

export const makeAppkitError = (
  e: TronWalletError | unknown
): TronAppkitError => {
  const error = factories.find(v => v.is(e))!.make(e as TronWalletError)
  console.debug({ makeAppkitError: error })
  return error
}
